import type { OwnerMailAddressDto } from '@his/shared';

const EMAIL_PATTERN = /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/;

export function parseAddressList(text: string): { valid: string[]; invalid: string[] } {
  const parts = text
    .split(/[\s,;]+/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
  const valid: string[] = [];
  const invalid: string[] = [];
  for (const part of parts) {
    if (EMAIL_PATTERN.test(part)) valid.push(part);
    else invalid.push(part);
  }
  return { valid: [...new Set(valid)], invalid };
}

export function replySubject(subject: string): string {
  const trimmed = subject.trim();
  return /^re:/i.test(trimmed) ? trimmed : `Re: ${trimmed}`;
}

export function senderLabel(from: OwnerMailAddressDto | null, unknown: string): string {
  if (!from) return unknown;
  if (from.name && from.address) return `${from.name} <${from.address}>`;
  return from.name ?? from.address ?? unknown;
}

export function quoteForReply(text: string, heading: string): string {
  const quoted = text
    .split(/\r?\n/)
    .map((line) => `> ${line}`)
    .join('\n');
  return `\n\n${heading}\n${quoted}`;
}

export function mailMessagesPath(folder: string, page: number, refresh = false): string {
  return `/owner/mail/messages?folder=${encodeURIComponent(folder)}&page=${page}${refresh ? '&refresh=1' : ''}`;
}

export function mailMessagePath(folder: string, uid: number): string {
  return `/owner/mail/messages/${uid}?folder=${encodeURIComponent(folder)}`;
}

export function mailAttachmentPath(folder: string, uid: number, index: number): string {
  return `/owner/mail/messages/${uid}/attachments/${index}?folder=${encodeURIComponent(folder)}`;
}
